<template>
  <div class="relative">
    <div
      style="position: absolute; z-index: 2; background-color: #000;"
      :style="vertical ? 'aspect-ratio: 9 / 16; left: 5.9%; top: 11%; width: 88.5%;' : 'aspect-ratio: 16 / 9; left: 11%; top: 4.8%; width: 78%;'"
    >
      <slot></slot>
    </div>
    <!--
    <v-img
      style="position: relative; z-index: 1; pointer-events: none;"
      width="100%" :aspect-ratio="vertical ? 355 / 720 : 720 / 355"
      :src="`https://cdn.ellacard.com/start/mobile-outline${vertical ? '-vertical' : ''}.png`"
    />
    -->
    <img
      style="position: relative; z-index: 1; pointer-events: none;"
      v-bind:style="{ 'aspect-ratio': vertical ? '355 / 720' : '720 / 355' }"
      width="100%"
      :src="`https://cdn.ellacard.com/start/mobile-outline${vertical ? '-vertical' : ''}.png`"
    />
  </div>
</template>

<script>
export default {
  name: 'outline-phone',
  props: { vertical: Boolean }
};
</script>
